import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import DashHudsonCarousel from '@/components/homepage/DashHudsonCarousel';

export default function BuilderDashHudsonCarousel({
  carouselID,
  carouselName,
  carouselSrc,
  header,
  cta,
  anchorLinkID,
  color,
  margin,
}) {
  const carouselNameProp = carouselName || 'likeshop-carousel';
  const carouselSrcProp = carouselSrc || '//cdn.dashhudson.com/web/js/carousel-embed.js';
  return (
    <div {...getAnchorId(anchorLinkID)}>
      <DashHudsonCarousel
        color={color}
        carouselID={carouselID}
        isFull
        carouselName={carouselNameProp}
        carouselSrc={carouselSrcProp}
        header={header}
        cta={cta}
        className={getComponentMargin(margin)}
      />
    </div>
  );
}
